<script>
let now = new Date();

let STORAGE_KEY = "tcs-courses";
let courseStorage = {
  fetch: function () {
    let courses = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    courses.forEach(function (course, index) {
      course.id = index;
    });
    courseStorage.uid = courses.length;

    return courses;
  },
  save: function (todos) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(todos));
  }
};

export default {
  props: {},
  data() {
    return {
      container: null,
      isLoaded: false,
      isValid: true,
      //courses: courseStorage.fetch(),
      courses: [],
      selectedLocation: "",
      selectedCourse: ""
    }
  },
  mounted() {
    this.container = document.querySelector('.js-vue-course-booking');

    this.load();
  },
  watch: {
    isLoaded: function (newVal) {
      if (newVal) {
        this.container.classList.remove('is-element-loading');
        this.container.classList.remove('has-hidden-children');
      }
    },
    // watch courses change for localStorage persistence
    courses: {
      handler: function (courses) {
        //courseStorage.save(courses);
      },
      deep: true
    }
  },
  methods: {
    load: function () {
      if (this.courses.length <= 0) {
        let _this = this;

        fetch("/ajax/courses", {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(_this.form)
        })
            .then(function (response) {
              return response.json();
            })
            .then(function (response) {
              if (response.success) {
                _this.courses = response.data;
                _this.isLoaded = true;
              }
            })
            .catch(function (error) {
              //...
            });
      } else {
        this.isLoaded = true;
      }
    },

    getPrettyName: function (course) {
      let courseString = new Date(course.DatumBeginn).toLocaleDateString('de-DE', {
        weekday: 'long',
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
      courseString += ' - ' + course.UhrzeitBeginn.substr(0, 5) + ' ' + this.getLocale(course);
      return courseString;
    },

    getLocale: function (course) {
      switch (course.KursSprache) {
        case 'D':
          return '(Deutsch)';
        case 'F':
          return '(Französisch)';
        case 'I':
          return '(Italienisch)';
      }
    },

    validate: function () {
      if (this.selectedCourse !== '') {
        this.isValid = true;
        window.open(this.buyUrl);

        return true;
      } else {
        this.isValid = false;

        return false;
      }
    }
  },

  computed: {
    uniqueLocations() {
      // only include 2 phases courses
      let courses = ['2-Phasen', '2-Phases', '2-Fasi']

      return [...new Set(this.courses.filter(function (course) {
        return course.FreiePlaetze > 0 && courses.includes(course.KursName.trim());
      }).map((course) => course.Gelaendebesch))];
    },

    filteredCourses() {
      let _this = this;

      // only include 2 phases courses
      let courses = ['2-Phasen', '2-Phases', '2-Fasi']

      return this.courses.filter(function (course) {
        return course.Gelaendebesch === _this.selectedLocation && course.FreiePlaetze > 0 && courses.includes(course.KursName.trim());
      });
    },

    coursePrice() {
      if (this.selectedCourse !== '') {
        return Intl.NumberFormat('en-CH', {
          style: 'currency',
          currency: 'CHF',
          useGrouping: false,
        }).format(this.selectedCourse.KursPreis);
      }

      return '';
    },

    coursePriceMG() {
      if (this.selectedCourse !== '') {
        return Intl.NumberFormat('en-CH', {
          style: 'currency',
          currency: 'CHF',
          useGrouping: false,
        }).format(this.selectedCourse.KursPreisMG);
      }

      return '';
    },

    buyUrl() {
      if (this.selectedCourse !== '') {
        return "https://www.rebus-net.com/mandanten/tttcs/OnlineBuchenCDC/kursart.php?fi=a1&gl=" + this.selectedCourse.GelaendeID + "&kn=" + this.selectedCourse.KursNr + "&sprache=1"
      }

      return '#';
    }
  }
};
</script>
